// extracted by mini-css-extract-plugin
export default {"checkboxRow":"PollForm_checkboxRow__l5t2N","checkboxColContainer":"PollForm_checkboxColContainer__hMRXv","formRow":"PollForm_formRow__+voDd"};